"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderIcon = exports.getPopupPosition = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = __importDefault(require("../Icon"));
var MaterialIcon_1 = __importDefault(require("../MaterialIcon"));
var getPopupPosition = function (menuItemRef, position) {
    var getPosition = function () {
        if (menuItemRef.current && position === 'bottom') {
            return menuItemRef.current.getBoundingClientRect().bottom;
        }
        return menuItemRef.current ? menuItemRef.current.getBoundingClientRect().top : 0;
    };
    var menuDistanceFromTop = menuItemRef.current
        ? getPosition() + menuItemRef.current.getBoundingClientRect().height
        : 0;
    return window.innerHeight - menuDistanceFromTop;
};
exports.getPopupPosition = getPopupPosition;
var renderIcon = function (icon) {
    if (icon.startsWith('agco_')) {
        return (0, jsx_runtime_1.jsx)(Icon_1.default, { name: icon.replace('agco_', '') });
    }
    return (0, jsx_runtime_1.jsx)(MaterialIcon_1.default, { name: icon });
};
exports.renderIcon = renderIcon;
